import React from "react";
import { Header } from "../components/landing/Header";
import { Hero } from "../components/landing/Hero";
import { AvailabilityBanner } from "../components/landing/AvailabilityBanner";
import { Services } from "../components/landing/Services";
import { BeforeAfter } from "../components/landing/BeforeAfter";
import { WhyChooseUs } from "../components/landing/WhyChooseUs";
import { ServiceArea } from "../components/landing/ServiceArea";
import { HowItWorks } from "../components/landing/HowItWorks";
import { QuoteForm } from "../components/landing/QuoteForm";
import { Footer } from "../components/landing/Footer";
import { Toaster } from "../components/ui/sonner";

export default function LandingPage() {
  return (
    <div className="font-body bg-white text-navy" data-testid="landing-page">
      <Header />
      <main>
        <Hero />
        <AvailabilityBanner />
        <Services />
        <BeforeAfter />
        <WhyChooseUs />
        <ServiceArea />
        <HowItWorks />
        <QuoteForm />
      </main>
      <Footer />
      <Toaster position="top-center" />
    </div>
  );
}
